export default {
  favorites: []
}
